import { Grid, FormControl, TextField, Button, SvgIcon, useTheme, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import { SearchSm } from '../../../assets';
import React, { useContext, useState } from 'react';
import { CreateInvoicesValues, InvoicesContext } from '../contexts/InvoicesContext';
import { InvoiceTable } from './InvoiceTable';
import { Section } from '../../../components/ui/Section';
import DatePickerLocalized from '../../../components/shared/DatePickerLocalized';
import dayjs from 'dayjs';
import { handleSearchFieldKeyDown } from '../../../utils';
import MessagesSnackbar from '../../../components/shared/MessagesSnackbar';
import { UserContext } from '../../../components/shared/useUser';
import InvoiceBulkManage from './InvoiceBulkManage';

export const InvoiceBox = () => {

  const { t, invoiceNumber, handleInvoiceNumberChange, handleEndDateChange, orderNumber, handleClearAllClick, handleOrderNumberChange, startDate, endDate, loadData, handleStartDateChange, handleOpenBulkManage, handleCloseBulkManage, openBulkManage } = useContext(InvoicesContext) as CreateInvoicesValues;
  const { hasPermissionTo } = useContext(UserContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`);
  const [showResultMessage, setShowResultMessage] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'info' | 'warning' }>({ open: false, message: '', severity: 'success' });
  
  return <Box sx={{ pt: '6px' }}>
    <Grid container
      spacing={5}>
      <Grid item
        sm={3}
        xs={6}>
        <FormControl fullWidth>
          <TextField label={t('invoiceNumber')}
            value={invoiceNumber}
            onChange={handleInvoiceNumberChange}
            onKeyDown={e => handleSearchFieldKeyDown(e, loadData)} />
        </FormControl>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <FormControl fullWidth>
          <TextField label={t('orderNumber')}
            value={orderNumber}
            onChange={handleOrderNumberChange}
            onKeyDown={e => handleSearchFieldKeyDown(e, loadData)} />
        </FormControl>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <FormControl fullWidth>
          <DatePickerLocalized
            useCalendar={false}
            label={t('startDate')}
            value={startDate}
            maxDate={dayjs(endDate)}
            onChange={handleStartDateChange} />
        </FormControl>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <FormControl fullWidth>
          <DatePickerLocalized
            useCalendar={false}
            label={t('endDate')}
            value={endDate}
            minDate={dayjs(endDate)}
            onChange={handleEndDateChange} />
        </FormControl>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <Button
          fullWidth
          variant="secondary"
          size="lg"
          onClick={handleClearAllClick}
        >
          {t('clearAll')}
        </Button>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <Button
          fullWidth
          variant="primary"
          size="lg"
          startIcon={<SvgIcon> <SearchSm /> </SvgIcon>}
          onClick={loadData}
        >
          {t('search')}
        </Button>
      </Grid>
      {hasPermissionTo(['InvoiceReconciliationAdmin']) && (
        <Grid item
          sm={2}
          xs={6}
          sx={{ marginLeft: isMobile ? '' : 'auto' }}>
          <Button
            fullWidth
            variant="secondary"
            size="lg"
            onClick={handleOpenBulkManage}
          >
            {t('bulkManage')}
          </Button>
        </Grid>
      )}
      <Grid item
        xs={12}>
        <Section>
          <InvoiceTable></InvoiceTable>
        </Section>
      </Grid>
    </Grid>
    <InvoiceBulkManage
      open={openBulkManage}
      handleClose={handleCloseBulkManage}
      onSuccess={(message) => {
        handleCloseBulkManage();
        setShowResultMessage({ open: true, message, severity: 'success' });
        loadData();
      }}
    />
    <MessagesSnackbar
      open={showResultMessage.open}
      onClose={() => setShowResultMessage({ ...showResultMessage, open: false })}
      message={showResultMessage.message}
      severity={showResultMessage.severity}
      duration={6000}
    />
  </Box>;
};